import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import BlogIndexPage from "./pages/BlogIndexPage";
import BlogPostPage from "./pages/BlogPostPage";
import ReviewsPage from "./pages/ReviewsPage";
import CalculatorPage from "./pages/CalculatorPage";
import ServicePage from "./components/ServicePage";
import CityPage from "./components/CityPage";
import LandingPage from "./components/LandingPage";
import CalcFunnelPage from "./components/CalcFunnelPage";
import FlagshipCityPage from "./components/FlagshipCityPage";
import GuidePage from "./components/GuidePage";
import DeniedClaimPage from "./components/DeniedClaimPage";
import BiohazardClaimPage from "./components/BiohazardClaimPage";
import CarrierPage from "./components/CarrierPage";
import UnderpaidClaimPage from "./components/UnderpaidClaimPage";
import NwflPage from "./components/NwflPage";
import GuidesHubPage from "./pages/GuidesHubPage";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/toaster";
import { damageServices, cities } from "./data/seoContent";
import { landingPages } from "./data/landingPages";
import { flagshipCities } from "./data/flagshipCities";
import { guidePages } from "./data/guidePages";
import { deniedClaims } from "./data/deniedClaims";
import { biohazardClaims } from "./data/biohazardClaims";
import { carriers } from "./data/carriers";
import { underpaidClaims } from "./data/underpaidClaims";
import { nwflPages } from "./data/nwfl";

// Wrapper to inject the resolved city slug
function CityPageWithSlug({ citySlug }) {
  return <CityPage citySlugOverride={citySlug} />;
}

// Single dynamic route handler that decides between:
//  - City pages: /public-adjuster-<slug>
//  - Damage type pages: /<damage-slug>
//  - 404
function DynamicRoute() {
  const { slug } = useParams();
  if (!slug) return <NotFound />;

  if (guidePages[slug]) {
    return <GuidePage />;
  }

  if (deniedClaims[slug]) {
    return <DeniedClaimPage />;
  }

  if (biohazardClaims[slug]) {
    return <BiohazardClaimPage />;
  }

  if (carriers[slug]) {
    return <CarrierPage />;
  }

  if (underpaidClaims[slug]) {
    return <UnderpaidClaimPage />;
  }

  if (nwflPages[slug]) {
    return <NwflPage />;
  }

  if (slug.startsWith("public-adjuster-")) {
    const cityKey = slug.replace("public-adjuster-", "");
    if (flagshipCities[cityKey]) {
      return <FlagshipCityPage slug={cityKey} />;
    }
    if (cities[cityKey]) {
      return <CityPageWithSlug citySlug={cityKey} />;
    }
    return <NotFound />;
  }

  if (landingPages[slug]) {
    return <LandingPage />;
  }

  if (damageServices[slug]) {
    return <ServicePage />;
  }
  return <NotFound />;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/blog" element={<BlogIndexPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/guides" element={<GuidesHubPage />} />
            <Route path="/claim-calculator" element={<CalculatorPage />} />
            <Route path="/roof-claim-calculator" element={<CalcFunnelPage slug="roof-claim-calculator" />} />
            <Route
              path="/water-damage-claim-calculator"
              element={<CalcFunnelPage slug="water-damage-claim-calculator" />}
            />
            <Route path="/:slug" element={<DynamicRoute />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
